import React, { useCallback, useState } from "react";
import {
  Box,
  Paper,
  Tooltip,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SyntaxHighlighter from "react-syntax-highlighter";
import { tomorrow } from "react-syntax-highlighter/dist/esm/styles/prism";

const JsonPrettyView = ({ prettifiedJson = "" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    if (!prettifiedJson) return;

    navigator.clipboard.writeText(prettifiedJson).then(() => {
      setCopied(true);
    });
  }, [prettifiedJson]);

  const handleClose = () => setCopied(false);

  const contentToDisplay =
    typeof prettifiedJson === "string"
      ? prettifiedJson
      : JSON.stringify(prettifiedJson, null, 2);

  return (
    <>
      <Paper elevation={3} sx={{ position: "relative", overflowX: "auto" }}>
        <Box sx={{ position: "absolute", right: 8, top: 8, zIndex: 1 }}>
          <Tooltip title="Copy to clipboard">
            <IconButton onClick={handleCopy}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
        <SyntaxHighlighter
          language="json"
          style={tomorrow}
          customStyle={{
            margin: 0,
            padding: "20px",
            borderRadius: "4px",
            fontSize: "14px",
            minHeight: "200px",
            background: "#2d2d2d",
          }}
        >
          {contentToDisplay || "// No content to display"}
        </SyntaxHighlighter>
      </Paper>

      <Snackbar
        open={copied}
        autoHideDuration={1500}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="success" onClose={handleClose} sx={{ width: "100%" }}>
          Copied to clipboard!
        </Alert>
      </Snackbar>
    </>
  );
};

export default JsonPrettyView;
